import { api } from "../api/apiCore";
import { cache, invalidateByPrefix } from '../utils/apiCache';
import { convertRangeToDateOnly } from '../component/helpers/timeDisplaySettings';

export function getDriverScoresByTimeframe(data) {
	const { start_ts, end_ts, company_id } = data;
	const url = `/driver/scoring?start_ts=${start_ts}&end_ts=${end_ts}&company_id=${company_id}`

	return api.get(url)
}

export function getDriverEventWeights(company_id) {
	const url = `/driver/scoring/weights?company_id=${company_id}`;

	return api.get(url)
}

export function updateEventWeights(data) {
	const url = `/driver/scoring/weights`

	const form = new FormData();
	form.append('company_id', data.company_id)
	form.append('weights', data.weights)

	return api.postForm(url, form);
}

export function getDriverCoachingData(data) {
	const url = `/driver/coaching?start_date=${data.start_date}&end_date=${data.end_date}&company_id=${data.company_id}`;

	return api.get(url)
}

export function createCoachingSession(data) {
	let url = `/driver/coaching`;

	const form = new FormData();
	for (let session of Object.entries(data)) {
		session[1] && form.append(session[0], session[1])
	}

	return api.putForm(url, form);
}

export function completeCoachingSesion(id) {
	const url = `/driver/coaching/${id}`
	let form = new FormData()
	form.append('status', 'complete')

	return api.postForm(url, form);
}

export function deleteCoachingSession(id) {
	let url = `/driver/coaching/${id}`;

	return api.delete(url);
}

export function sendDriverQRCode(driver_id) {
	const url = `/driver/${driver_id}/qrcode`

	return api.postForm(url);
}

export function deleteDriver(data) {
	const url = `/driver/${data.driverId}`;

	return api.delete(url).then((res) => {
		invalidateByPrefix('drivers:');
		return res;
	});
}

export function addDriver(data) {
	const url = `/driver`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('drivers:');
		return res;
	});
}

export function uploadDrivers(data) {
	const url = `/driver/upload?bell_notifs=true`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('drivers:');
		return res;
	});
}


export function editDriver(driver_id, data) {
	const url = `/driver/${driver_id}`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('drivers:');
		return res;
	});
}

export function associateDriverWithTrip(data) {
	const url = `/associate/driver/withtrip`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function associateDriverCardTrip(data) {
	const { driverId, ...rest } = data;
	const url = `/driver/${driverId}/associate/cardtrip`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function getDriverAlerts(data) {
	const { driver_id, allowDeviceTz, ...rest } = data;
	convertRangeToDateOnly(rest, 'start_ts', 'end_ts', allowDeviceTz)

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/driver/${driver_id}/alerts${params}`;

	return api.get(url);
}

export function getDriverTripById(data) {
	const { driver_trip_id } = data;

	const url = `/driver/trip/${driver_trip_id}`;

	return api.get(url);
}

export function getAvailableDriverAvatars(data) {
	const { driver_id, page_number = 1, page_size = 100 } = data;

	const url = `/driver/${driver_id}/trips_photos?page_number=${page_number}&page_size=${page_size}`;

	return api.get(url);
}

export function addDriverAvatars(data) {
	const { driver_id, trip_photos_ids } = data;

	const url = `/driver/${driver_id}/avatars`;

	const form = new FormData();
	form.append('trip_photos_ids', trip_photos_ids);

	return api.postForm(url, form).then(res => {
		invalidateByPrefix('drivers:');
		return res;
	});
}

export function removeDriverAvatars(data) {
	const { driver_id, avatar_ids } = data;

	const url = `/driver/${driver_id}/avatars`;

	const form = new FormData();
	form.append('avatar_ids', avatar_ids);

	return api.delete(url, { data: form }).then(res => {
		invalidateByPrefix('drivers:');
		return res;
	});
}
